import { VenueShowType } from '@api';
import {
  SearchTableInput,
  TouringCard,
  TouringCardActions,
  TouringCardHeader,
  TouringCardSection,
  TouringCardTitle,
  TouringDataTable,
  useManageTableContext,
} from '@common';
import { useColumns } from './hooks';

type VenueShowsTablePropsType = {
  title: string;
  shows: VenueShowType[];
  isFetching: boolean;
  dataTestId: string;
};

export const VenueShowsTable: React.FC<VenueShowsTablePropsType> = ({
  title,
  shows,
  isFetching,
  dataTestId,
}) => {
  const { columns } = useColumns();

  const {
    tableArguments: {
      pagination,
      search: { searchValue, setSearchValue },
    },
  } = useManageTableContext();

  return (
    <TouringCard data-testid={dataTestId}>
      <TouringCardHeader>
        <TouringCardTitle>{title}</TouringCardTitle>
        <TouringCardActions>
          <SearchTableInput
            search={searchValue ?? ''}
            setSearchValue={setSearchValue}
          />
        </TouringCardActions>
      </TouringCardHeader>
      <TouringCardSection>
        <TouringDataTable<VenueShowType>
          records={shows}
          columns={columns}
          fetching={isFetching}
          withTableBorder={false}
          {...pagination}
        />
      </TouringCardSection>
    </TouringCard>
  );
};
